import InnerPageThesis from './innerPageThesis'
import TemplateMain from '../templateMain'

export default function PageHome () {
  return (
    <TemplateMain
      g_section='portfolio'
      htmlTitle='Masters Thesis'
      linksTitle='Other Publications'
      innerPage={<InnerPageThesis />}
      g_sidebarKey='pagePublications2'
      g_slideshowKey=''
    />
  )
}
